<div class="px-5 md:px-14 bg-gray-90 hover:cursor-pointer flex items-center h-16">
  <a class="logo" href="/">
    <img class="inline" priority ngSrc="empikfoto/logo_white.svg" width="149" height="36" alt="Empik Foto" />
  </a>
</div>
